/**
 * User slice — stores the authenticated user's profile fields decoded from the JWT.
 * Populated via setUser on sign-in; individual fields can be updated without a
 * full re-login (e.g. setUserBaId when the user switches Business Administration,
 * setUserLanguageId when they switch language preference).
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SLICE_BASE_NAME } from './constants'

export type UserState = {
    avatar?: string
    userName?: string
    email?: string
    authority?: string[]
    userId?: number
    baId?: number
    languageId?: number
    expTime?: number // Store as timestamp (number) instead of Date
}

const initialState: UserState = {
    avatar: '',
    userName: '',
    email: '',
    authority: [],
    userId: 0,
    baId: 0,
    languageId: 0,
    expTime: undefined,
}

const userSlice = createSlice({
    name: `${SLICE_BASE_NAME}/user`,
    initialState,
    reducers: {
        setUser(state, action: PayloadAction<UserState>) {
            state.avatar = action.payload?.avatar
            state.email = action.payload?.email
            state.userName = action.payload?.userName
            state.authority = action.payload?.authority
            state.userId = action.payload?.userId
            state.baId = action.payload?.baId
            state.languageId = action.payload?.languageId
            state.expTime = action.payload?.expTime
        },
        setUserBaId(state, action: PayloadAction<number>) {
            state.baId = action.payload
        },
        setUserLanguageId(state, action: PayloadAction<number>) {
            state.languageId = action.payload
        },
    },
})

export const { setUser, setUserBaId, setUserLanguageId } = userSlice.actions
export default userSlice.reducer
